import Parse from "parse";

export const addNewVehicleVendor = (data) => {
    return Parse.Cloud.run("addNewVehicleVendor", data);
}

export const getVendorsListInRegion = (filters) => {
    return Parse.Cloud.run("getVendorsListInRegion", filters)
}
